import { Map } from 'immutable';

const ModuleStateModel = Map({
  flags: Map(),
});

export default ModuleStateModel;
